import { DEFAULT_LOCALE, UserLocale } from '@/shared/config';

export const getIntlMessages = async (
  locale: UserLocale = DEFAULT_LOCALE,
): Promise<Record<string, string>> =>
  import(`../../shared/locales/${locale}.json`).then((m) => m.default);
